// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SSQd","name":"styles_name__1On88","phone":"styles_phone__9LEDn"};